import {PLAN_TYPES, type PlanType} from '../../_context/PlanTypeContext'

import styles from './PlanTypeSegmentedControl.module.css'

type Props = {
  value: PlanType
  onChange: (value: PlanType) => void
}

export function PlanTypeSegmentedControl(props: Props) {
  const {value, onChange} = props

  return (
    <>
      <div className={styles.container} role="tablist" aria-labelledby="pricing-plans">
        <button
          className={`${styles.segment} ${value === PLAN_TYPES.Individual ? styles.active : ''}`}
          id="individual-plan-tab"
          onClick={() => onChange(PLAN_TYPES.Individual)}
          role="tab"
          aria-selected={value === PLAN_TYPES.Individual}
          aria-controls="individual-plan-tab-panel"
        >
          For individuals
        </button>

        <button
          className={`${styles.segment} ${value === PLAN_TYPES.Business ? styles.active : ''}`}
          id="business-plan-tab"
          onClick={() => onChange(PLAN_TYPES.Business)}
          role="tab"
          aria-selected={value === PLAN_TYPES.Business}
          aria-controls="business-plan-tab-panel"
        >
          For businesses
        </button>
      </div>
    </>
  )
}

try{ PlanTypeSegmentedControl.displayName ||= 'PlanTypeSegmentedControl' } catch {}